import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, QueryList } from '@angular/core';
import { PersonalFileInfo } from '../../../shared/models/PersonalFileInfo';
import { FileUploadResponse } from '../../../shared/models/file';
//import { ActiveProjectService } from 'src/app/modules/shared/services/activeProject/activeProject.service';
import { AlertService } from '../../../shared/services/alert/Alert.service';

import { FileService } from '../../../shared/services/file/file.service';

@Component({
  selector: 'app-fileUploadItem',
  templateUrl: './fileUploadItem.component.html',
  styleUrls: ['./fileUploadItem.component.css']
})
export class FileUploadItemComponent implements OnInit, OnDestroy {

  @Input() file!: File;
  @Input() title!: string;
  @Output() setFileInfo: EventEmitter<PersonalFileInfo> = new EventEmitter();
  @Output() setDone: EventEmitter<File> = new EventEmitter();

  public fileInfo: PersonalFileInfo = new PersonalFileInfo();

  progressPercent: number = 0;
  public isRunning: boolean = false;
  isDone: boolean = false;
  errortext: string = "";

  constructor(/*private activeProjectService: ActiveProjectService,*/ private FileService: FileService, private alertService: AlertService) { }


  ngOnDestroy(): void {
    this.isRunning = false;
    this.isDone = true;
    this.setDone.emit(this.file);
  }

  ngOnInit() {
    let self = this;
  }

  startUpload() {
    let self = this;
    if (this.isRunning) return;
    if (this.isDone) return;
    self.isRunning = true;

    let file = this.file;
    self.fileInfo.fileName = file.name;
    self.fileInfo.fileBytes = file.size;
    self.progressPercent = 0;

    self.FileService.uploadFileChunked(/*self.activeProjectService.projectId*/"1234", file.name, file
    , ( percent: number)=>{
        self.progressPercent = percent;
        if(!self.isRunning) {
          self.progressPercent = -1;
          self.alertService.setWarning("Abbruch Upload " + file.name);
        }
        return self.isRunning;
      }
    , ( result: FileUploadResponse)=>{
      self.progressPercent = -1;
      self.fileInfo.fileName = file.name;
      self.fileInfo.fileBytes = file.size;
      self.isRunning = false;
      self.publishFileInfoIfValidOrNull();
      }
      , ( error: any)=>{
        self.progressPercent = -1;
        self.fileInfo.fileName = file.name;
        self.fileInfo.fileBytes = file.size;
        self.isRunning = false;
        self.alertService.setError("Fehler bei Datei " + file.name);
        self.errortext = error.error ? error.error : "Unbekannter Fehler";
      })
  }

  onClear() {
    var self = this;
    self.isRunning = false;
    self.isDone = true;
    self.progressPercent = -1;
    this.setDone.emit(this.file);
  }

  publishFileInfoIfValidOrNull() {
    var self = this;
    self.isDone = true;
    if (self.fileInfo.fileName) {
      self.setFileInfo.emit(self.fileInfo);
    } else {
      self.setFileInfo.emit(undefined);
    }
    this.setDone.emit(this.file);
  }
}
